import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, createVNode as _createVNode, withCtx as _withCtx, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, renderList as _renderList, Fragment as _Fragment, normalizeClass as _normalizeClass } from "vue"

const _hoisted_1 = { class: "pb-8px h-full flex flex-col" }
const _hoisted_2 = { class: "title" }
const _hoisted_3 = {
  key: 1,
  class: "imageList mb-16px"
}
const _hoisted_4 = ["onClick"]
const _hoisted_5 = { class: "List" }
const _hoisted_6 = {
  key: 0,
  class: "py-8px text-center text-12px text-[#999]"
}
const _hoisted_7 = {
  key: 1,
  class: "py-8px text-center text-12px text-[#999]"
}
const _hoisted_8 = { key: 3 }

import { onMounted, ref } from 'vue'
import { ArrowDown, Search, ArrowLeft } from '@element-plus/icons-vue'
import { getVectorCategory, recommendations, getmaterials, getCollectionItems, getMaterialsItems, getVectorList } from '@/api/affairs'
import { ElIcon, ElInput, ElButton, ElPagination, ElEmpty } from 'element-plus'

// @ts-ignore
import elementItem from './elementItem.vue'

export default /*@__PURE__*/_defineComponent({
  __name: 'elementlist',
  props: {
    category: {},
    searchShow: { type: Boolean },
    categoriesShow: { type: Boolean },
    type: {},
    searchValue: {}
  },
  emits: ["back"],
  setup(__props: any, { emit: __emit }) {

const props = __props
const selectedCategory = ref('all') // 默认选中"全部"
const title = ref('')
let page = ref({
    pageNum: 1,
    pageSize: 30,
    type: 1,
})
const listItems = ref([]);
const pagetotle = ref(0);
const scrollRef = ref<HTMLElement | null>(null)
const loadingMore = ref(false)
const currentPage = ref(1)
const pageSize = ref(50)
const hasMore = ref(true)
const resetPagination = () => {
    page.value.pageNum = 1;
    pagetotle.value = 0;
    listItems.value = [];
}

const onScroll = (e: Event) => {
    const el = (e.target as HTMLElement) || scrollRef.value
    if (!el || !hasMore.value || loadingMore.value) return
    const nearBottom = el.scrollTop + el.clientHeight >= el.scrollHeight - 16
    if (nearBottom) {
        currentPage.value += 1
        getlist(props.type != 'svg' ? (props?.category?.id || '') : selectedCategory.value, currentPage.value, true)
    }
}

let category_Id = ref('')
let keywords = '';
onMounted(async () => {
    currentPage.value = 1
    hasMore.value = true
    if (props.categoriesShow) {
        await getCategory()
        return
    }
    getlist((props?.category?.id || ''), currentPage.value, true)


    // getmaterialsList(props.categoriesElementList.id, true, '')
})
const categoryList = ref('')
const categoriesElementList = ref([])
const getCategory = async () => {
    getVectorCategory({ page: 1, size: 100, id: props?.category?.id || '' }).then(res => {
        categoryList.value = res.data.data.items
        selectedCategory.value = res.data.data.items[0]?.id || ''
        getlist(selectedCategory.value, currentPage.value, false)
        return
    })
}
const allpage = ref(1)
const getlist = (categoryId: string | number, pageNo = 1, append = false) => {
    const apiMap: Record<string, Function> = {
        collect: getCollectionItems,
        materials: getMaterialsItems,
        svg: getVectorList,
    };
    const apiFunc = apiMap[props.type as string] || getmaterials;
    loadingMore.value = append
    apiFunc({ page: pageNo, size: pageSize.value, category_id: categoryId, name: props.searchValue || '' }).then((res: any) => {
        const items = res?.data?.data?.items || []
        if (append) {
            listItems.value = listItems.value.concat(items)
        } else {
            listItems.value = items
        }
        allpage.value = res?.data?.data?.total_pages || allpage.value
        hasMore.value = pageNo < allpage.value
    }).finally(() => {
        loadingMore.value = false
    })
}






const emit = __emit

const handleSearch = () => {

}

const handleBack = () => {
    emit('back')
}

const handleCategorySelect = (categoryId: string | number) => {
    selectedCategory.value = categoryId.toString()
    getlist(selectedCategory.value, 1, false)
    // resetPagination(); // 重置分页
    // if (categoryId === 'all') {
    //     getmaterialsList(props.categoriesElementList.id, true, '')
    // } else {
    //     getmaterialsList(categoryId, true, '')
    // }
    // selectedCategory.value = categoryId
    // emit('categorySelect', categoryId)
}


return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    (props.category && props.category.name)
      ? (_openBlock(), _createElementBlock("div", {
          key: 0,
          class: "header flex items-center gap-8px pb-16px cursor-pointer w-full",
          onClick: handleBack
        }, [
          _createVNode(_unref(ElIcon), { class: "back-icon cursor-pointer" }, {
            default: _withCtx(() => [
              _createVNode(_unref(ArrowLeft))
            ]),
            _: 1
          }),
          _createElementVNode("div", _hoisted_2, _toDisplayString(props.category.name), 1)
        ]))
      : _createCommentVNode("", true),
    (__props.categoriesShow)
      ? (_openBlock(), _createElementBlock("div", _hoisted_3, [
          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(categoryList.value, (item) => {
            return (_openBlock(), _createElementBlock("div", {
              key: item.id,
              class: _normalizeClass(["menu-items", { active: selectedCategory.value == item.id }]),
              onClick: ($event: any) => (handleCategorySelect(item.id))
            }, _toDisplayString(item.name), 11, _hoisted_4))
          }), 128))
        ]))
      : _createCommentVNode("", true),
    (listItems.value.length != 0)
      ? (_openBlock(), _createElementBlock("div", {
          key: 2,
          class: _normalizeClass(["pageList overflow-auto", { 'h-[calc(100%-80px)]': __props.categoriesShow }]),
          ref_key: "scrollRef",
          ref: scrollRef,
          onScroll: onScroll
        }, [
          _createElementVNode("div", _hoisted_5, [
            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(listItems.value, (item) => {
              return (_openBlock(), _createElementBlock("div", {
                key: item.id,
                class: "image-item"
              }, [
                _createVNode(elementItem, { template: item }, null, 8, ["template"])
              ]))
            }), 128))
          ]),
          (loadingMore.value)
            ? (_openBlock(), _createElementBlock("div", _hoisted_6, "加载中..."))
            : (!hasMore.value)
              ? (_openBlock(), _createElementBlock("div", _hoisted_7, "已无更多"))
              : _createCommentVNode("", true)
        ], 34))
      : _createCommentVNode("", true),
    (listItems.value.length === 0)
      ? (_openBlock(), _createElementBlock("div", _hoisted_8, [
          _createVNode(_unref(ElEmpty), { description: "暂无数据" })
        ]))
      : _createCommentVNode("", true)
  ]))
}
}

})